'use client';
import { FC } from 'react';
import Image from 'next/image';

import Text from '@/components/common/Text/Text';

import CloseIcon from 'public/img/icon/close.svg';

import './PriveeInvitedBanner.style.scss';

export type PriveeInvitedBannerProps = {
  onAccept: () => void;
  onDismiss: () => void;
};

const BANNER_TEXT =
  'You’ve been selected for Réservé, our most exclusive tier.';
const CTA_TEXT = 'Accept my invitation';

const PriveeInvitedBanner: FC<PriveeInvitedBannerProps> = ({
  onAccept,
  onDismiss
}) => {
  return (
    <div className='PriveeInvitedBanner'>
      <button
        type='button'
        className='PriveeInvitedBanner-close'
        onClick={onDismiss}
        aria-label='Dismiss Réservé invitation banner'
      >
        <Image
          alt=''
          src={CloseIcon}
          height={20}
          width={20}
        />
      </button>

      {/* Mobile: inline text + link + arrow */}
      <div className='PriveeInvitedBanner-mobile'>
        <Text
          variant='title-xs'
          className='PriveeInvitedBanner-mobile-text'
        >
          {BANNER_TEXT}{' '}
          <button
            type='button'
            className='PriveeInvitedBanner-mobile-link'
            onClick={onAccept}
          >
            {CTA_TEXT}
          </button>
          {' →'}
        </Text>
      </div>

      {/* Desktop: body text + button-styled CTA */}
      <Text
        variant='title-xs'
        className='PriveeInvitedBanner-desktop-text'
      >
        {BANNER_TEXT}
      </Text>
      <button
        type='button'
        className='PriveeInvitedBanner-desktop-button'
        onClick={onAccept}
      >
        <Text
          variant='title-xxs-500-upper'
          className='PriveeInvitedBanner-desktop-button-text'
        >
          {CTA_TEXT}
        </Text>
      </button>
    </div>
  );
};

export default PriveeInvitedBanner;
